export default __webpack_public_path__ + "static/media/treadmill.d8a81933.svg";